var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('banner-home'),_c('sobre'),(_vm.autorizado)?_c('cursos'):_vm._e(),_c('novidades'),_c('contato'),_c('rodape')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }